/**
 * Describes capabilities actually delivered by the backoffice foundation.
 */

export interface BackofficeFoundationStatus {
  readonly application: string;
  readonly capabilities: readonly string[];
}

/**
 * Returns immutable foundation metadata for the internal application.
 */
export function GetBackofficeFoundationStatus(): BackofficeFoundationStatus {
  return {
    application: "Backoffice",
    capabilities: [
      "Enrutamiento tipado por dominio",
      "Tokens visuales compartidos",
      "Build y ejecución independientes",
    ],
  };
}
